import { Box, Tooltip } from "@mui/material"



export const CowtypeListBadge = ({ cow_list }) => {
    if (cow_list && cow_list.length > 0) {
        const red = cow_list.filter(c => c.cow_type === 'red')
        const black = cow_list.filter(c => c.cow_type === 'black')
        let title = ''
        if (black.length > 0) {
            title = 'Black: ' + black.length
        }
        if (red.length > 0) {
            title = title += ' Red: ' + red.length
        }

        return (
            <Tooltip title={title}>
                <Box sx={{ borderRadius: 2, display: 'inline-flex', flexDirection: "row", fontSize: '0.8em', overflow: 'auto' }}>
                    {black.length > 0 && <Box sx={{ minWidth: '20px', backgroundColor: 'black', color: 'white', textAlign:'center' }}>{black.length}</Box>}
                    {red.length > 0 && <Box sx={{ minWidth: '20px', backgroundColor: 'red', color: 'white', textAlign:'center' }}>{red.length}</Box>}
                </Box>
            </Tooltip>
        )
    } else {
        return <></>
    }
}

